import OrderList from '@/data/order/view/list.vue'
import OrderDetail from '@/data/order/view/detail.vue'

const list = {
  path: '/order',
  name: 'order-list',
  component: OrderList
}

const detail = {
  path: '/order/:id(\\d+)',
  name: 'order-detail',
  component: OrderDetail
}

const listOfTeamBuying = {
  path: '/order-of-teambuying',
  name: 'order-list-of-teambuying',
  component: OrderList
}

export default [list, detail, listOfTeamBuying]
